import { useGet } from './useApi'
import { Gallery } from 'rhg-components-template/entities'

export const useFetchGallery = async (galleryId, galleryTitle, galleriesData = undefined) => {
  const [type] = galleryId.split('|')
  try {
    switch (type) {
      case 'hotel':
        return getGalleryFromHotel(galleryId, galleriesData)
      case 'rooms':
        return getGalleryFromRooms(galleryId, galleriesData, galleryTitle)
      case 'roomList':
        return getGalleryListFromRooms(galleryId, galleriesData, galleryTitle)
      case 'generic':
        return getGenericGallery(galleryId, galleriesData, galleryTitle)
      default:
        throw new Error(`The type <b>${type}</b> is not supported in gallery-app`)
    }
  } catch (error) {
    console.error(error)
    return {}
  }
}

const getGenericGallery = async (compoundId, rawData, galleryTitle) => {
  const [type, galleryTypeId] = compoundId.split('|')

  const galleryData = rawData.generic?.galleries

  return galleryData
    ? [Gallery.fromJSON(`${type}|${galleryTypeId}`, galleryData, galleryTitle)]
    : [{}]
}

const getGalleryFromHotel = async (compoundId, rawData) => {
  const [type, hotelId] = compoundId.split('|')
  const data = rawData || (await useGet(`/content-api/hotels/${hotelId}`, { origin: 'PUBLIC' }))

  const galleryData = data.hotel?.galleries

  const galleryTitle = Object.hasOwn(data.hotel, 'name') ? data.hotel?.name : ''

  return galleryData ? [Gallery.fromJSON(`${type}|${hotelId}`, galleryData, galleryTitle)] : [{}]
}

const getGalleryFromRooms = async (compoundId, rawData, galleryTitle) => {
  const [type, hotelId] = compoundId.split('|')
  const data =
    rawData || (await useGet(`/content-api/hotels/${hotelId}/rooms`, { origin: 'PUBLIC' }))

  const galleries = data.rooms
    .filter(room => !!room.galleryExtended)
    .map(room =>
      Gallery.fromJSON(`${type}|${hotelId}|${room.code}`, [room.galleryExtended], galleryTitle)
    )

  return galleries || []
}
const getGalleryListFromRooms = async (compoundId, rawData, galleryTitle) => {
  const [type, hotelId] = compoundId.split('|')
  const data =
    rawData || (await useGet(`/content-api/hotels/${hotelId}/rooms`, { origin: 'PUBLIC' }))

  const galleryData = data.rooms
    .filter(room => !!room.galleryExtended)
    .map(room => room.galleryExtended)
  return galleryData ? [Gallery.fromJSON(`${type}|${hotelId}`, galleryData, galleryTitle)] : [{}]
}

export const useFetchGalleryFromGlobal = async () => {
  if (!Array.isArray(window.galleriesData)) return []

  const galleries = await Promise.all(
    window.galleriesData?.map(async gallery => {
      const galleryId = `${gallery.data.type}|${gallery.data.id}`
      return useFetchGallery(galleryId, gallery.data.galleryTitle, gallery.json)
    })
  )

  return galleries.flat()
}
